module.exports = __webpack_public_path__ + "static/media/Barboach_gaussian2.1056a5d7.png";